













































import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { DataTableHeader } from 'vuetify';
import { Alert, NoticeClass, AuthStore } from '@kasasa/fbase-components/lib';
import { QualificationSummary, QualificationSummaryResource } from '@/api/qualificationsummary';
import {
  FiConfiguration, FiConfigurationResource, ReportResource, Report,
} from '@/api/reports';
import { Cycle } from '@/api/cycles';
import ReportDownloader from '@/components/reports/ReportDownloader.vue';

@Component({
  computed: mapState(['fiId']),
  components: { ReportDownloader },
})
export default class QualificationSummaryCard extends Vue {
  @Prop({ default: null }) cycle!: Cycle | null;

  fiId!: string;

  loading: boolean = true;

  headers: DataTableHeader[] = [
    { text: 'Product', value: 'productName' },
    { text: 'Qual Level', value: 'qualLevel' },
    { text: 'Number of Accounts', value: 'numberOfAccounts' },
    { text: '% Qualified', value: 'percentQualified' },
    { text: '% Not Qualified', value: 'percentNotQualified' },
    { text: 'File Name', value: 'fileName' },
  ];

  items: QualificationSummary[] = [];

  fiReportFileFormat: string | null = null;

  reportFileNames: string[] = [];

  downloadReportFileName: string | null = null;

  @Inject('QualificationSummaryResource')
  qualificationSummaryResource!: QualificationSummaryResource;

  @Inject('FiConfigurationResource')
  fiConfigurationResource!: FiConfigurationResource;

  @Inject('ReportResource')
  reportResource!: ReportResource;

  mounted() {
    this.loadData();
  }

  @Watch('cycle')
  async loadData() {
    if (this.cycle) {
      this.loading = true;
      this.items = [];

      await this.getFiReportFileFormat();

      await this.getReportsForCycle();

      await this.qualificationSummaryResource.getQualificationSummary(this.fiId, this.cycle.id)
        .then((results: QualificationSummary[]) => {
          this.items = results.filter((summary: QualificationSummary) => summary.qualLevel !== null && summary.qualLevel !== undefined && summary.qualLevel !== 0);
        }).catch((error: any) => {
          this.showErrorMessage(error);
        }).finally(() => {
          this.loading = false;
        });
    }
  }

  async getReportsForCycle() {
    this.reportFileNames = [];
    if (this.cycle && this.fiReportFileFormat) {
      await this.reportResource.getReportInfos(this.fiId, this.cycle.id, this.fiReportFileFormat)
        .then((results: Report[]) => {
          results.forEach((report: Report) => {
            this.reportFileNames.push(report.filename);
          });
        }).catch((error: any) => {
          this.showErrorMessage(error);
        });
    }
  }

  async getFiReportFileFormat() {
    this.fiReportFileFormat = null;
    await this.fiConfigurationResource.getFiConfiguration(this.fiId)
      .then((config: FiConfiguration) => {
        this.fiReportFileFormat = config.fiReportFileFormat;
      }).catch((error: any) => {
        this.showErrorMessage(error);
      });
  }

  getQualReportNameForProduct(productName: string): string {
    let reportName: string = '';
    if (this.fiReportFileFormat) {
      reportName = `${productName.replace(/\s|:|-/g, '_')}_product_qual_report.${this.fiReportFileFormat.toLowerCase()}`;
    }
    return reportName;
  }

  downloadReport(fileName: string) {
    this.downloadReportFileName = fileName;
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
